<dw-router-parent [useIf]="false" (reactivated)="restorePosition()">
<ng-template>
<main class="recipients-list" [attr.aria-busy]="loading">
  <app-season-banner label="Why we streak" heading="Meet the recipients" [challenge]="currentChallenge"></app-season-banner>
  <div class="recipient-page recipients-list-content">
    <p class="recipients-list-intro">Every streak has a story behind it. Meet the people who bring our season of giving to life.</p>
    <nav *ngIf="!loading && groups.length" class="recipient-seasons" aria-label="Choose a recipient season">
      <button type="button" *ngFor="let group of groups" (click)="selectSeason(group)"
        [class.selected]="selected?.id === group.id" [title]="group.name"
        [attr.aria-pressed]="selected?.id === group.id">{{ group.label }}</button>
    </nav>
    <app-recipient-loading-skeleton *ngIf="loading"></app-recipient-loading-skeleton>
    <div *ngIf="error" role="alert"><p>{{ error }}</p><button type="button" class="btn btn-outline-primary" (click)="reload()">Try again</button></div>
    <section *ngIf="!loading && !error && selected" [attr.aria-label]="selected.label">
      <div class="recipient-season-heading"><h2>{{ selected.label }}</h2><span *ngIf="selected.recipients.length">{{ selected.recipients.length }} {{ selected.recipients.length === 1 ? 'story' : 'stories' }}</span></div>
      <app-recipient-cards [recipients]="selected.recipients" [seasonLabel]="selected.label" [detailBase]="storyBase"></app-recipient-cards>
      <p *ngIf="!selected.recipients.length" class="recipients-empty">Recipients will be introduced here as their stories are revealed.</p>
    </section>
    <p *ngIf="!loading && !error && !selected" class="recipients-empty">Previous recipient stories will appear here.</p>
  </div>
</main>
</ng-template>
</dw-router-parent>
